var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flow-item bt-d-flex bt-align-items-center border border-rounded-sm p-2"},[_c('div',{staticClass:"flow-item-days bt-d-flex bt-align-items-center mr-1"},[_c('b',{staticClass:"mr-1"},[_vm._v("After")]),_c('InputV2',{staticStyle:{"width":"60px"},attrs:{"type":"number","value":_vm.timeframe},on:{"input":function($event){return _vm.changeTimerame($event)}}}),_c('span',{staticClass:"ml-1"},[_vm._v("Days")])],1),_c('div',{staticClass:"flow-item-actions"},[_c('b',{staticClass:"mr-1"},[_vm._v("Then")]),(_vm.flowAction !== _vm.ECollectionFlowActions.NONE)?_c('InputV2',{attrs:{"disabled":"","value":_vm.flowActionLabel}}):_vm._e(),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"action-item",class:{'first-action': (_vm.flowAction === _vm.ECollectionFlowActions.NONE && index === 0)}},[(!(_vm.flowAction === _vm.ECollectionFlowActions.NONE && index === 0))?_c('b',{staticClass:"mr-1"},[_vm._v(" and ")]):_vm._e(),_c('AccordionSelect',{attrs:{"placeholder":"Choose Action","selected":item.template,"items":[
        //     {
        //   title: 'Send Letter',
        //   key: 'send-letter',
        //   items: letterTemplatesItemList,
        //   extraButton: {
        //     label: 'Add New Letter',
        //     click: handleAddNewTemplate(ETemplateType.LETTER),
        //     type: 'secondary',
        //     size: 'large'
        //   }
        // },
        // {
        //   title: 'Add Statement Message',
        //   key: 'add-statement-message',
        //   items: messageTemplatesItemList,
        //   extraButton: {
        //     label: 'Add New Statement Message',
        //     click: handleAddNewTemplate(ETemplateType.MESSAGE),
        //     type: 'secondary',
        //     size: 'large'
        //   }
        // },
        //  {
        //   title: 'Write Off',
        //   key: 'write-off',
        //   items: writeOffItemList,
        //   disabledItems: disabledActionNames
        // },
        {
          title: 'Collections',
          key: 'collections',
          items: _vm.collectionsItemList,
          disabledItems: _vm.disabledActionNames
        }
        ]},on:{"select":function($event){return _vm.selectFlowItem(item, $event)}}}),_c('Icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remove'),expression:"'Remove'"}],attrs:{"clickable":"","icon":"trash"},on:{"click":function($event){return _vm.removeItem(index)}}})],1)}),_c('button',{staticClass:"link plus-left ml-1",on:{"click":function($event){return _vm.addItem()}}},[_vm._v(" Action ")])],2),(!this.default)?_c('Icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remove'),expression:"'Remove'"}],attrs:{"icon":"trash","clickable":""},on:{"click":function($event){return _vm.$emit('removeTimeframe', _vm.index)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }